import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSyncAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import {
	Table,
	Column,
	Pager,
	Avatar,
	fullName,
	Button,
	Select
} from '@smartplatform/ui';
import t from '../../../i18n';
import './style.scss'
import { debounce } from 'lodash';

const PER_PAGE = 14;

@inject('store', 'uiStore') @observer
class List extends React.Component {
	@observable isInitialized = false;
	@observable isLoading = false;
	@observable records = null;
	@observable search = '';
	@observable roles = null;
	@observable roleId = null;
	@observable page = 1;
	@observable filter = {
		where: {},
		order: 'id asc',
		fields: ['id', 'roleId', 'principalId'],
	};

	constructor(props) {
		super(props);
		this.store = props.store;
		this.doSearch = debounce(this.init, 250, { leading: false, trailing: true });
		props.uiStore.setBar(<h1>{t('User.plural')}</h1>);
		this.init();
	}

	init = async () => {
		this.isLoading = true;
		if (!this.roles) {
			this.roles = await this.store.Role.find({ order: 'name asc' })
		};
		const roleMappings = await this.store.RoleMapping.find(this.filter);
		const trimmed = this.search.trim();
		const where = { and: [] }
		if (roleMappings && this.roleId) where.and.push({ id: { inq: roleMappings.map(item => item.principalId) } })
		if (trimmed.length > 0) where.and.push({
			or: [
				{ username: { ilike: `%${trimmed}%` } },
				{ email: { ilike: `%${trimmed}%` } },
				{ firstName: { ilike: `%${trimmed}%` } },
				{ middleName: { ilike: `%${trimmed}%` } },
				{ lastName: { ilike: `%${trimmed}%` } },
			]
		}
		)
		this.records = await this.store.User.find({
			where,
			order: 'id asc',
			skip: (this.page - 1) * PER_PAGE,
			limit: PER_PAGE,
		});

		this.isLoading = false;
		this.isInitialized = true;
	};

	onSearch = e => {
		this.search = e.target.value;
		this.doSearch();
	};

	create = () => {
		this.props.history.push(`/admin/users/create`);
	};

	reload = (e) => {
		e.preventDefault();
		this.init();
	};

	onPageChange = async (page) => {
		this.page = page;
		this.init();
	};

	onRoleChange = async (id) => {
		this.page = 1;
		this.roleId = id;
		this.filter.where = { roleId: id };
		if (!id) {
			this.filter.where = {};
		}
		this.init();
	};
	getRoleName = () => {
		const role = this.roles.find((role) => role.id === this.roleId)
		if (role) {
			return role.name
		}
		return <span style={{ color: "#777777" }}>Фильтр по роли</span>;
	}
	onClearAll = () => {
		this.page = 1;
		this.roleId = null;
		this.search = '';
		this.init();
	}

	render() {
		if (!this.isInitialized) return '...';

		return <div className="table-list">
			<div className="table-list-panel">
				<div className="create-btn">
					<Button onClick={this.create} className="btn-primary" icon={<FontAwesomeIcon icon={faPlus} />}>{t('create')}</Button>
				</div>
				<div className="search-input">
					<input type="text" value={this.search} onChange={this.onSearch} placeholder="Поиск" />
				</div>
				<div style={{ width: '150px', marginRight: '30px' }}>
					<Select
						className="drop-down-md in-table-input"
						showValue={this.getRoleName()}
						onChange={id => this.onRoleChange(id)}
						items={
							this.roles.map(role => ({ value: role.id, label: role.name }))} />
				</div>
				<Button className='btn-primary' onClick={this.onClearAll}>
					<FontAwesomeIcon icon={faFilter} /> очистить </Button>

			</div>

			{this.isLoading
				? <div className="loading-msg">Загрузка...</div>
				: <>
					<Pager
						itemsPerPage={PER_PAGE}
						totalCount={this.records.totalCount}
						current={this.page}
						onChange={this.onPageChange}
					/>
					<Table className="table-list-table" records={this.records} rootPath="/admin">
						<Column label={t('User.avatar')} width={30}>
							{user => <Avatar user={user} size={30} />}
						</Column>
						<Column property="username" label={t('User.username')} />
						<Column property="email" label={t('User.email')} />
						<Column computed={fullName} property="lastName" label={t('User.fullName')} />
						<Column property="emailVerified" label={t('User.emailVerified')} />
					</Table>
				</>}
		</div>;
	}
}

export default List;
